// extracted by mini-css-extract-plugin
export default {"popperDiv":"PopperComponent_popperDiv__igyYK"};